import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import styled from 'styled-components'

const TourDarkSuccessPromotionLabel = styled(PromotionLabel)`
  &&& {
    background-color: ${props => props.theme.palette.messaging.success.darkBackground};
    border-color: ${props => props.theme.palette.messaging.success.darkForeground};
    color: ${props => props.theme.palette.messaging.success.darkContrast};
  }

  &&& > svg,
  &&& > * {
    color: ${props => props.theme.palette.messaging.success.darkContrast};
  }
`

export default TourDarkSuccessPromotionLabel
